<div class="onboarding-page-overlay" [style.top]="overlayTop"></div>

<div class="secondary-content" [ngClass]="{'secondary-content-mobile': !(windowService.isDesktopRes$ | async)}">
  <tidy-row [align]="'center'" [ngStyle]="(windowService.isDesktopRes$ | async) ? {'margin-bottom': '30px'} : {'margin-bottom': '10px'}">
    @if (windowService.isDesktopRes$ | async) {
      <tidy-text
        [heroBody]="pageData?.description"
        class="white" />
    }
    @if (!(windowService.isDesktopRes$ | async)) {
      <tidy-text
        [largeBody]="pageData?.description"
        class="white" />
    }
  </tidy-row>
  <tidy-button
    [text]="pageData?.buttonText"
    (click)="dismissAboutThisPage()"
    class="primary full-width" />
</div>
